import { render, staticRenderFns } from "./TVShow1.vue?vue&type=template&id=0d7f0501&scoped=true&"
import script from "./TVShow1.vue?vue&type=script&lang=js&"
export * from "./TVShow1.vue?vue&type=script&lang=js&"
import style0 from "./TVShow1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7f0501",
  null
  
)

export default component.exports